<template>
  <div class="container">

    <div class="info">
      CAAC是中国民用航空局（Civil Aviation Administration of China）的英文缩写。是由中国民航局直接颁发的《民用无人驾驶航空器操控员执照》，是目前国内最具权威性、通用性和法律效力的无人机驾照。
    </div>
    <div class="top-img flex flex-center">
      <img src="@/assets/case/wrj1.png" alt=""/>
    </div>
    <div class="bottom">
      <div class="title">CAAC无人机驾驶执照：行业必备通行证</div>
      <div class="list">
        <div class="item" v-for="item in list">
          <div class="name">{{ item }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        "自 2024 年 1 月 1 日起，《无人驾驶航空器飞行管理暂行条例》正式施行，明确规定操控小型、中型、大型民用无人机人员需持有民用无人机驾驶航空器操控员执照。持有者可进行空域申报、航线申请，并开展与无人机相关的商业活动。尽管驾驶微型或轻型无人机不需要执照，但在某些特定区域，仍需持有无人机执照才能申请空域进行飞行，且飞行高度必须限制在120米以内，否则将被视为“黑飞”。此外，获得CAAC执照后，还可以额外获得AOPA/ALPA执照。这一法规的实施，使得 CAAC 执照成为无人机行业从业者入行的必备敲门砖。",
        "拥有CAAC无人机执照表明，您已获得合法使用相应类别和级别无人机执行商业飞行的权益，并可申请作业空域，这对于开展各类无人机业务极为关键。此外，在向空军和航管部门提交飞行计划申请时，CAAC执照也是必要的人员证件之一。",
        "CAAC无人机执照根据机型可分为多旋翼、垂直起降固定翼、固定翼和直升机四种；根据重量可分为微型无人机（250克以下）、小型无人机（250克至25公斤之间）、中型无人机（25公斤至150公斤之间）和大型无人机（超过150公斤）；根据等级可分为视距内驾驶员、超视距驾驶员和教员三种。不同的等级和机型适用于各种飞行场景和业务需求。一般来说，对于普通无人机爱好者，考取视距内驾驶员证即可满足日常飞行需求。"
      ],
    }
  },
  methods: {},
  created() {

  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 500px;
  padding: 0 70px;
  background: url("~@/assets/case/product-detail-bg.png") no-repeat;
  background-position-y: bottom;
  background-size: contain;

  .top-img {
    margin-bottom: 59px;

    img {
      width: 679px;
      height: 357px;
    }
  }

  .info {
    text-indent: 2em;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
    margin-bottom: 59px;

  }

  .bottom {
    .title {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      line-height: 36px;
      margin-bottom: 6px;

      text-indent: 20em;
    }

    .list {
      margin-bottom: 30px;

      .item {
        font-size: 20px;
        font-weight: 400;
        color: #333333;
        line-height: 36px;

        .name {
          font-size: 20px;
          color: #333333;
          line-height: 40px;
        text-indent: 2em;
        }
      }
    }
  }
}
</style>
